<template>
  <div class="content-8">

    <div class="content-8__titlebar">
      <div class="content-8__titlebar__left">
        <div class="c8-titlename">
          <span class="c8-titlename__text">号码规律统计</span>
        </div>
      </div>
      <div class="content-8__titlebar__right">
        <lottery-date-filter-tab @updateForm="chooseDate" />
      </div>
    </div>
    <loading v-if="isLoading" />
    <template v-else>
      <template v-if="hmGuiLuStatsList['cpRuleDetails'].length > 0">
        <div class="content-8__controlbar">
          <div class="content-8__controlbar__item">
            <div class="c8-explanation">
              <div class="c8-explanation__icon"></div>
              <span class="c8-explanation__title">说明：</span>
              <div class="c8-explanation__content">
                <p>
                  1.【号码规律统计】提供号码开出位置的历史同位号码统计。例如第1期开出号码1后，
                  在第1期开出号码1的相同位置，第2期开出号码为2，则把号码2标示
                </p>
                <p>2. 柱形图表为历史同位开出号码的次数分布，用于查看已开出号码的分布及趋势，亦可作为参考辅助杀号</p>
              </div>
            </div>
          </div>
          <div class="content-8__controlbar__item">
            <div class="c8-select">
              <div class="c8-select__title">
                <span class="c8-select__title__text">号码筛选：</span>
              </div>
              <div class="c8-select__content">
                <a
                  v-for="item in hmList"
                  :key="item.label"
                  class="button-outline c8-select__content__item"
                  :class="{'active': currentHm === item.key}"
                  @click="changeHm(item)"
                >
                  <span class="button-outline__text">{{ item.label }}</span>
                </a>
              </div>
            </div>
          </div>
          <div class="content-8__controlbar__item">
            <div class="fn-chart-trend">
              <v-chart :options="chartOptions" />
            </div>
          </div>
        </div>
        <div class="content-8__content">
          <table draw-root class="even-color fn-position-relative">
            <thead>
              <tr>
                <th rowspan="2" style="width: 300px;">期号 时间</th>
                <th rowspan="2" style="width: 400px;">
                  <div class="tablecheckbox">
                    <span class="tablecheckbox__text">同位开奖号码分布：</span>
                    <div
                      class="checkbox tablecheckbox__item"
                      :class="{'active': activeHm}"
                      @click="activeSameDigit"
                    >
                      <i class="checkbox__select"></i>
                      <label class="checkbox__label">显示同位号码</label>
                    </div>
                  </div>
                </th>
                <th rowspan="2">升平降</th>
                <th colspan="2">单双</th>
                <th colspan="2">大小</th>
              </tr>
              <tr>
                <th>单</th>
                <th>双</th>
                <th>大</th>
                <th>小</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in tableList" :key="`rowData-${row.period}-${row.drawTime}`">
                <td>
                  <div class="continuous-text">
                    <span class="continuous-text__text">{{ `${row.period} ` }}</span>
                    <span class="continuous-text__text blue">{{ `${row.drawTime}` }}</span>
                  </div>
                </td>
                <td>
                  <div class="tableballbox">
                    <div
                      v-for="ballObj in row.balls[currentHm]"
                      :key="ballObj.ball"
                      class="tableballbox__item"
                      :draw-me="ballObj.beDrawn"
                    >
                      <div class="ball size-middle" :class="[ballObj.beLinked, setCurrentHm(ballObj)]">
                        <span class="ball__number">{{ ballObj.ball }}</span>
                      </div>
                    </div>
                  </div>
                </td>
                <td :class="setTextColor(row.hmGueiLyuShengPingJiang[currentHm])">{{ row.hmGueiLyuShengPingJiang[currentHm] }}</td>
                <td :class="setTextColor(row.hmDanShuang_dan[currentHm])">{{ row.hmDanShuang_dan[currentHm] }}</td>
                <td :class="setTextColor(row.hmDanShuang_shuang[currentHm])">{{ row.hmDanShuang_shuang[currentHm] }}</td>
                <td :class="setTextColor(row.hmDaXiao_da[currentHm])">{{ row.hmDaXiao_da[currentHm] }}</td>
                <td :class="setTextColor(row.hmDaXiao_xiao[currentHm])">{{ row.hmDaXiao_xiao[currentHm] }}</td>
              </tr>
            </tbody>
          </table>
          <div class="scrollBottom"></div>
        </div>
      </template>
      <NoData v-else />
    </template>
  </div>
</template>

<script>
import { getHaoMaGuiLu_web } from '@/api/desktop/statistic'
import { hmList, haoMaGuiLu_method } from '@/utils/forWeb-Sean/haoMaGuiLu'

import LotteryDateFilterTab from '@/components/web/pages/trend/LotteryDateFilterTab'
import Loading from '@/components/web/common/Loading'
import NoData from '@/components/web/common/NoData'
export default {
  name: 'WebHaoMaGuiLuTongJi',
  components: {
    LotteryDateFilterTab,
    Loading,
    NoData
  },
  data() {
    return {
      lotteryCode: this.$route.params.lottery_code,
      hmGuiLuStatsList: {
        cpRuleDetails: [],
        numberCounts: null
      },
      chartOptions: {
        color: ['#348AFF'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            label: {
              show: true
            },
            shadowStyle: {
              color: '#E8F3FF',
              opacity: 0.5
            }
          },
          formatter: '{b}<br>次数{c}',
          textStyle: {
            width: 20,
            height: 20
          },
          position: function(point, params, dom, rect, size) {
            return [point[0], '10%']
          }
        },
        grid: {
          top: 60,
          bottom: 60,
          left: '10%',
          right: '10%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [
              '号码 1',
              '号码 2',
              '号码 3',
              '号码 4',
              '号码 5',
              '号码 6',
              '号码 7',
              '号码 8',
              '号码 9',
              '号码 10'
            ],
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            max: 0,
            minInterval: 1
          }
        ],
        series: [
          {
            type: 'bar',
            barWidth: '70%',
            data: []
          }
        ]
      },
      hmList,
      currentHm: 'num1',
      isLoading: false,
      chunkData: {
        index: 0,
        list: [],
        _observer: null
      },
      tableList: [],
      activeHm: false,
      periodFormat: {
        count: 30
      }
    }
  },
  beforeDestroy() {
    this.removeTrendCanvas()
  },
  updated() {
    this.activeLazyLoading()
  },
  methods: {
    ...haoMaGuiLu_method,
    async init() {
      this.isLoading = true
      await this.getHaoMaGuiLuStatistics()
      this.isLoading = false
      this.setChart()
      this.setTable()
      this.drawTrendCanvas()
    },
    async getHaoMaGuiLuStatistics() {
      var params = {
        code: this.lotteryCode,
        rules: 'hmDaXiao,hmDanShuang',
        ...this.periodFormat
      }
      const [data, error] = await getHaoMaGuiLu_web(params)
      if (error) return
      Object.assign(this.hmGuiLuStatsList, data)
    },
    changeHm(item) {
      this.currentHm = item.key
      this.setChart()
      this.drawTrendCanvas()
    },
    chooseDate(form) {
      this.periodFormat = { ...form }
      this.init()
    }
  }
}
</script>

<style lang="scss" scoped>
.fn-chart-trend {
  width: 74.125rem;
  height: 24.125rem;
}
.fn-position-relative {
  position: relative;
}
.c8-explanation:hover {
  height: auto;
}
table {
  table-layout: fixed;
}
.scrollBottom {
  height: 50px;
  opacity: 0;
}
</style>
